<div class="dialog-header">
  <div class="dialog-header--text">
    <h2>{{ 'COM.TABS.OPEN.CHART.EDIT_TITLE' | translate }}</h2>
    <p class="selected-date">{{ data.metadata.date.toDate() | date: 'EEE, d MMMM' }}</p>
  </div>
  <button class="cancel-icon" (click)="onCancel()">
    <dr-customer-offers-ui-icons name="close" size="extra-small" state="primary"></dr-customer-offers-ui-icons>
  </button>
</div>
<form [formGroup]="offerForm">
  <mat-dialog-content class="dialog-content">
    <ng-container *ngFor="let dim of dimensions">
      <h4 class="slot-time">
        {{ dim.labelKey | translate }}
        <p *ngIf="dim.key === 'DEMAND_FORECAST'">*</p>
      </h4>

      <ng-container *ngIf="isDimensionConsolidated(dim.key); else perSlot">
        <div class="time-slots-container" [formArrayName]="dim.key">
          <div class="time-slot">
            <mat-form-field appearance="outline" class="value-input value-input--no-error-message">
              <span class="value-input--header">
                {{ currentHourData.timeSlots[0].formattedTime }} -
                {{ getEndTime(getLastSlotEndTime(currentHourData), data.metadata.frequency) }}
              </span>
              <input
                matInput
                type="number"
                step="0.1"
                [formControlName]="0"
                [attr.data-testid]="'dim-input-' + dim.key + '-0'"
                (input)="updateValue(currentHourData.timeSlots[0].time, dim.seriesName, dim.key, $event, currentHourData)"
              />
              <span matSuffix class="unit">{{ dim.unit }}</span>
            </mat-form-field>
          </div>
        </div>
      </ng-container>

      <ng-template #perSlot>
        <div class="time-slots-container" [formArrayName]="dim.key">
          <div *ngFor="let slot of currentHourData.timeSlots; let i = index" class="time-slot">
            <mat-form-field appearance="outline" class="value-input value-input--no-error-message">
              <span class="value-input--header">{{ slot.formattedTime }} - {{ getEndTime(slot.formattedTime, data.metadata.frequency) }}</span>
              <input
                matInput
                type="number"
                step="0.1"
                [formControlName]="i"
                [attr.data-testid]="'dim-input-' + dim.key + '-' + i"
                (input)="updateValue(slot.time, dim.seriesName, dim.key, $event, currentHourData)"
              />
              <span matSuffix class="unit">{{ dim.unit }}</span>
            </mat-form-field>
          </div>
        </div>
      </ng-template>

      <div class="help-text">
        <ng-container *ngIf="getSlots(dim.key) as slots">
          <ng-container *ngIf="getFirstFormArrayError(slots) as err">
            <div
              class="error-message"
              [class.error-message--container]="
                slots.touched && ([FormErrorType.min, FormErrorType.max].includes(err) || (dim.errorRequiredKey && err === FormErrorType.required))
              "
            >
              <mat-error *ngIf="[FormErrorType.min, FormErrorType.max].includes(err) && slots.touched">
                {{ dim.errorRangeKey | translate }} {{ dim.rangeMin
                }}<ng-container *ngIf="dim.rangeMax !== null"> {{ 'COM.TABS.OPEN.CHART.TO' | translate }} {{ dim.rangeMax }}</ng-container>
              </mat-error>
              <mat-error *ngIf="dim.errorRequiredKey && err === FormErrorType.required && slots.touched">
                {{ dim.errorRequiredKey | translate }}
              </mat-error>
            </div>
          </ng-container>
        </ng-container>

        <p class="dimension-note" *ngIf="!isOptOutEnabled && dim.noteKey">
          {{ dim.noteKey | translate }}
        </p>
      </div>
    </ng-container>

    <ng-container *ngIf="isOptOutEnabled">
      <h4 class="slot-time">{{ 'COM.CHECKBOX.OPT_OUT' | translate }}</h4>
      <div class="optout-container" formArrayName="optOut">
        <div *ngFor="let slot of currentHourData.timeSlots; let i = index" class="time-slot opt-out-slot">
          <span class="value-input--header">{{ slot.formattedTime }} - {{ getEndTime(slot.formattedTime, data.metadata.frequency) }}</span>
          <mat-checkbox [formControlName]="i" color="primary" [attr.data-testid]="'optout-' + i">{{
            'COM.CHECKBOX.OPT_OUT' | translate
          }}</mat-checkbox>
        </div>
      </div>
    </ng-container>
  </mat-dialog-content>
</form>

<mat-dialog-actions align="end" class="dialog-actions">
  <button style="border-radius: 1.875rem" mat-stroked-button color="primary" (click)="onCancel()">{{ 'COM.BUTTONS.CANCEL' | translate }}</button>
  <button
    (click)="onSave()"
    mat-flat-button
    color="primary"
    class="round-button"
    [disabled]="offerForm.invalid || !hasPendingChanges"
    data-testid="apply-button"
  >
    {{ 'COM.BUTTONS.APPLY' | translate }}
  </button>
</mat-dialog-actions>
